<template>
  <div>
    <el-card shadow="always">
      <EditForm
        ref="editForm"
        :disabled="isDisableEditForm"
        :userReimbursementCode="params.code"
      />
      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
        >
          {{ $l('btn_save') || '保存' }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'personal-myReimbursement-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
